import {createContext} from 'react'

const UbicacionesContext = createContext()

export default UbicacionesContext